import Image from 'gatsby-image';
import React from 'react';
import styled from '@emotion/styled'

const PersonCardImageComponent = ({ image, className }) => (
  <ImageWrapper className={className}>
    <Image {...image} />
  </ImageWrapper>
);

const ImageWrapper = styled.div`
    width: 100%;
    max-width: 680px;
    min-width: 50%;
    background-color: rgba(0, 0, 0, 0.1);
    display: block;
    &::before {
        content: '';
        width: 1px;
        margin-left: -1px;
        float: left;
        height: 0;
        padding-top: 66.66666666%;
    }
    &::after {
        content: '';
        display: table;
        clear: both;
    }
`;
export default PersonCardImageComponent;
